<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1024 1024"
>
  <path
    fill="#0a0b0f"
    d="M512 960c-92.8 0-160-200-160-448S419.2 64 512 64s160 200 160 448-67.2 448-160 448zm0-32c65.6 0 128-185.6 128-416S577.6 96 512 96 384 281.6 384 512s62.4 416 128 416z"
  />
  <path
    fill="#667099"
    d="M124.8 736c-48-80 92.8-238.4 307.2-363.2S852.8 208 899.2 288 806.4 526.4 592 651.2 171.2 816 124.8 736zm27.2-16c33.6 57.6 225.6 17.6 424-97.6S905.6 361.6 872 304s-225.6-17.6-424 97.6S118.4 662.4 152 720z"
  />
  <path
    fill="#f0f1f5"
    d="M899.2 736c-46.4 80-254.4 38.4-467.2-84.8S76.8 368 124.8 288s254.4-38.4 467.2 84.8S947.2 656 899.2 736zM872 720c33.6-57.6-97.6-203.2-296-318.4S184 246.4 152 304s97.6 203.2 296 318.4S840 777.6 872 720z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M512 592c-44.8 0-80-35.2-80-80s35.2-80 80-80 80 35.2 80 80-35.2 80-80 80zM272 312c-27.2 0-48-20.8-48-48s20.8-48 48-48 48 20.8 48 48-20.8 48-48 48zm144 568c-27.2 0-48-20.8-48-48s20.8-48 48-48 48 20.8 48 48-20.8 48-48 48zm448-432c-27.2 0-48-20.8-48-48s20.8-48 48-48 48 20.8 48 48-20.8 48-48 48z"
  />
</svg>
